import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Complaint_Report_Filter from "./complaint_report_filter/Complaint_Report_Filter";
import Complaint_Report_Table from "./complaint_report_table/Complaint_Report_Table";
import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";

const Complaint_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Complaint Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Complaint_Report_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Complaint_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Complaint Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Complaint_Report;
